import config from '@app/config'
import { createInstance } from '@app/services/api/createInstance'

type ClientSwitchCodeResponse = {
  statusCode: number
  result?: {
    code?: string
  }
}

const generateDashboardRedirectLink = ({
  b2bLoginUrl,
  switchCode,
  dashboardUrl,
  sourceDomain,
}: {
  b2bLoginUrl: string
  switchCode: string
  dashboardUrl: string
  sourceDomain: string
}): string | null => {
  let loginUrl: URL

  try {
    loginUrl = new URL(b2bLoginUrl)
  } catch {
    return null
  }

  if (!loginUrl.hostname) {
    return null
  }

  const stateParams = sourceDomain
    ? new URLSearchParams({ sourceDomain }).toString()
    : ''
  const state = stateParams ? `/?${stateParams}` : '/'

  loginUrl.searchParams.set('code', switchCode)
  loginUrl.searchParams.set('redirect_uri', dashboardUrl)
  loginUrl.searchParams.set('state', btoa(state))

  return loginUrl.toString()
}

export const switchToDashboardScreen = async () => {
  const b2bClientId = config.variables.b2b_clientId
  const dashboardBaseUrl = (
    config.variables.dashboardLink ||
    config.identity.website ||
    '/'
  ).replace(/\/+$/, '')

  if (!config.identity.identityUrl) {
    window.location.assign(config.identity.website || '/')
    return
  }

  if (!b2bClientId) {
    window.location.assign(config.identity.website || '/')
    return
  }

  try {
    const idApi = createInstance({ baseURL: config.identity.identityUrl })
    const { data } = await idApi.get<ClientSwitchCodeResponse>(
      '/api/users/clientswitchCode',
      {
        params: {
          targetClientId: b2bClientId,
        },
      }
    )

    const code = data?.statusCode === 200 ? data.result?.code : null
    if (!code) {
      window.location.assign(config.identity.website || '/')
      return
    }

    const b2bLoginUrl = new URL(
      '/api/users/clientswitchCode/callback',
      config.identity.identityUrl
    ).toString()
    const dashboardAuthUrl = new URL(
      '/api/users/auth',
      dashboardBaseUrl
    ).toString()
    const sourceDomain =
      window.location.hostname || new URL(dashboardBaseUrl).hostname

    const redirectLink = generateDashboardRedirectLink({
      b2bLoginUrl,
      switchCode: code,
      dashboardUrl: dashboardAuthUrl,
      sourceDomain,
    })

    if (!redirectLink) {
      window.location.assign(config.identity.website || '/')
      return
    }

    window.location.assign(redirectLink)
  } catch (error) {
    console.error('Failed to switch to dashboard screen', error)
    window.location.assign(config.identity.website || '/')
  }
}
